import { GuidHelper } from "@/Common/Helpers/GuidHelper";

class CounterOrderModel {
    private id: string;
    private label: string;
    private value: string;
    private extra: CounterOrderModelExtra[];
    private onValueChanged: (value: string) => void;

    constructor(
        label: string,
        value: string,
        onValueChanged: (value: string) => void,
        extra?: CounterOrderModelExtra[]
    ) {
        this.id = GuidHelper.NewGuid();
        this.label = label;
        this.value = value;
        this.onValueChanged = onValueChanged;
        this.extra = extra ?? [];
    }

    public get Id(): string {
        return this.id;
    }

    public get Label(): string {
        return this.label;
    }

    public get Value(): string {
        return this.value;
    }

    public get Extra(): CounterOrderModelExtra[] {
        return this.extra;
    }

    public setValue(value: string): void {
        this.value = value;
        this.onValueChanged?.(this.value);
    }

    public setNumberValue(value: number): void {
        this.setValue(value > 0 ? `+${value}` : value?.toString());
    }

    public hasValue(): boolean {
        return !!this.value;
    }

    public setExtraValue(id: string, isCheck: boolean): void {
        this.extra = this.extra.mutate(x => x.IsCheck = isCheck, x => x.Id === id);
    }

    public hasExtra(): boolean {
        return this.extra.any();
    }
}

class CounterOrderModelExtra {
    private id: string;
    private label: string;
    private isCheck: boolean;
    private onValueChanged: (isCheck: boolean) => void;

    constructor(label: string, isCheck: boolean, onValueChanged?: (isCheck: boolean) => void) {
        this.id = GuidHelper.NewGuid();
        this.label = label;
        this.isCheck = isCheck;
        this.onValueChanged = onValueChanged;
    }

    public get Id(): string {
        return this.id;
    }

    public get Label(): string {
        return this.label;
    }

    public get IsCheck(): boolean {
        return this.isCheck;
    }

    public set IsCheck(value: boolean) {
        this.isCheck = value;
        this.onValueChanged?.(this.isCheck);
    }
}

export { CounterOrderModel, CounterOrderModelExtra };
